/*
 Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 Licensed under the Amazon Software License (the "License"). You may not use this file
 except in compliance with the License. A copy of the License is located at

 http://aws.amazon.com/asl/

 or in the "license" file accompanying this file. This file is distributed on an "AS IS"
 BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
 License for the specific language governing permissions and limitations under the License.
 */

import Vue from 'vue';
import Router from 'vue-router';
import LexWeb from 'components/LexWeb';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LexWeb',
      component: LexWeb,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js